module.exports = __webpack_public_path__ + "static/media/farmfresh.e83061d5.png";